import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/login.css"; // Upewnij się, że ten plik istnieje

const LoginForm = ({ onLoginSuccess }) => {
  const [login, setLogin] = useState("");
  const [haslo, setHaslo] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
  
    try {
      const response = await fetch('/api/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, haslo })
      });
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        onLoginSuccess();
        navigate('/admin');
      } else {
        setError(data.error || 'Błąd logowania');
      }
    } catch (err) {
      setError('Błąd połączenia z serwerem');
    }
  };
  

  return (
    <div className="login-form">
      <h2>Logowanie</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="login">Login</label>
        <input
          id="login"
          type="text"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          placeholder="Wprowadź login"
        />

        <label htmlFor="haslo">Hasło</label>
        <input
          id="haslo"
          type="password"
          value={haslo}
          onChange={(e) => setHaslo(e.target.value)}
          placeholder="Wprowadź hasło"
        />

        {error && <p className="error">{error}</p>}

        <button type="submit">Zaloguj</button>
      </form>
    </div>
  );
};

export default LoginForm;
